var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"context-menu",class:{arrow: _vm.topArrow, 'submenu-content': _vm.subMenu, 'white-theme': _vm.whiteTheme},style:({ top: (_vm.top + 8) + 'px', left: _vm.left + 'px' , bottom: _vm.bottom + 'px'})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }